export const TAB_KEYS = {
  quoteDetails: 'QuoteDetailsForm',
  transportationDetails: 'TransportationDetails',
  productDetails: 'ProductDetails',
  shippingTerms: 'ShippingTermsSearchForm',
  notes: 'NotesDetails',
  documents: 'DocumentDetails',
  collaborators: 'QuoteCollboratorLogs',
  bidding: 'QuoteBiddingLogs',
};

export const SECTIONS_BY_FORMS = {
  quoteDetailsForm: TAB_KEYS.quoteDetails,
  stopsForm: TAB_KEYS.transportationDetails,
  productForm: TAB_KEYS.productDetails,
  shippingTermsSearchForm: TAB_KEYS.shippingTerms,
  notesForm: TAB_KEYS.notes,
  documentForm: TAB_KEYS.documents,
};

export const transportationGroupData = [
  {
    id: 'EXPL',
    value: 'Explosives',
  },
  {
    id: 'RACT',
    value: 'Radioactive',
  },
  {
    id: 'STD',
    value: 'Standard',
  },
];

export const transportationModeData = [
  {
    key: 'AIR',
    value: 'AIR',
  },
  {
    key: 'OCN',
    value: 'OCEAN',
  },
  {
    key: 'TRK',
    value: 'TRUCK',
  },
  {
    key: 'TRD',
    value: 'DOMESTIC TRUCKING',
  },
  {
    key: 'RLR',
    value: 'RAILROAD',
  },
  {
    key: 'INA',
    value: 'INTRA AIR',
  },
];
